import React, { useState, useImperativeHandle } from 'react';
import { Form } from 'react-bootstrap';
import '../sharedFormControl.css'
import NumberFormat from 'react-number-format';

const SSN = (props, ref) => {

    useImperativeHandle(ref, () => ({ isValid }), [props.value]);

    const isValid = () => {

        if (props.required && props.value && props.value.length === 9)
            return true;
        else if (props.required && (!props.value || (props.value && props.value.length !== 9)))
            return false;

        return true;

    }

    const onChange = (val) => {

        if (props.onChange)
            props.onChange(props.objectKey, val);

    }

    return (
        <React.Fragment>
            <fieldset className={`${props.zeroMargin ? 'default-fieldset mb-0' : 'default-fieldset'}`}>
                {!props.hideLegend ? <legend className='default-fieldset-label'>{props.label ? props.label : 'SSN'}</legend> : null}
                <NumberFormat
                    required={props.required}
                    name="dealershipPhoneNumber"
                    placeholder="000-00-0000"
                    disabled={props.disabled}
                    value={props.value ? props.value : ''}
                    format='###-##-####'
                    onValueChange={(values) => onChange(values.value)}
                />
            </fieldset>
            {/* <Form.Control.Feedback type="invalid">
                {props.errorMessage ? props.errorMessage : `Please enter a valid ${props.name}.`}
            </Form.Control.Feedback> */}
            {props.required && props.validated && !isValid() ? <span className='input-error-message'>{props.errorMessage ? props.errorMessage : `Please enter a valid ${props.name}.`}</span> : null}
        </React.Fragment>
    )

}

export default React.forwardRef(SSN);